import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import pdf from "../../Assets/Soheel Gadad resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js";

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function nextPage() {
    if (pageNumber < numPages) setPageNumber(pageNumber + 1);
  }

  function prevPage() {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  }

  return (
    <Container fluid className="resume-section">
      <Container>
        <h1 className="project-heading" style={{ textAlign: "center" }}>
          My <span className="gradient-text">Resume</span>
        </h1>

        <Row className="resume" style={{ justifyContent: "center", marginTop: 24 }}>
          <Document
            file={pdf}
            onLoadSuccess={onDocumentLoadSuccess}
            className="d-flex justify-content-center"
            loading="Loading resume preview..."
            error="Sorry, the resume preview could not be loaded. Use the download button below instead."
          >
            <Page
              pageNumber={pageNumber}
              scale={width > 786 ? 1.7 : 0.6}
              renderTextLayer={false}
            />
          </Document>
        </Row>

        {numPages > 1 && (
          <Row
            style={{
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button className="btn btn-outline" onClick={prevPage} style={{ padding: "8px 18px" }}>
              ‹ Prev
            </button>
            <span style={{ color: "var(--text-accent)", fontWeight: 500 }}>
              Page {pageNumber} of {numPages}
            </span>
            <button className="btn btn-outline" onClick={nextPage} style={{ padding: "8px 18px" }}>
              Next ›
            </button>
          </Row>
        )}

        <Row style={{ justifyContent: "center", position: "relative", marginTop: 24, marginBottom: 20 }}>
          <a href={pdf} target="_blank" rel="noreferrer" className="btn btn-hire">
            <AiOutlineDownload /> &nbsp;Download Resume (PDF)
          </a>
        </Row>
      </Container>
    </Container>
  );
}

export default ResumeNew;